import React from 'react';
import styled from '@emotion/styled';

import { Colors } from '../constants';

const Container = styled.div`
  width: 100%;

  border-bottom: 1px solid ${Colors.Container.border};

  display: flex;
  align-items: center;

  padding: 1.1rem 0;
`;

const Brand = styled.div`
  flex-grow: 1;
  margin-left: 3%;

  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 750px) {
    margin-left: 5%;
  }
`;

const Title = styled.a`
  font-family: 'Roboto Slab', serif;
  font-size: 28px;
  font-weight: 400;
  line-height: 1.15;
  letter-spacing: -0.01em;

  color: ${Colors.Text.base};
  text-decoration: none;

  &:hover {
    color: ${Colors.Text.hover};
  }

  &:active {
    color: ${Colors.Text.active};
  }
`;

const Tagline = styled.div`
  margin-top: 0.2rem;

  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.01em;
  color: ${Colors.Text.Faint.base};

  @media (max-width: 750px) {
    display: none;
  }
`;

const Navigation = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1.5rem;

  margin-right: 3%;

  @media (max-width: 750px) {
    margin-right: 5%;
    gap: 1rem;
  }
`;

const NavLink = styled.a`
  font-size: 15px;
  font-weight: 400;

  cursor: pointer;
  user-select: none;

  color: ${Colors.Text.Faint.base};
  text-decoration: none;

  &:hover {
    color: ${Colors.Text.base};
  }

  &:active {
    color: ${Colors.Text.active};
  }

  @media (max-width: 750px) {
    display: none;
  }
`;

const NavLinkKeep = styled.a`
  font-size: 15px;
  font-weight: 400;

  cursor: pointer;
  user-select: none;

  color: ${Colors.Text.Faint.base};
  text-decoration: none;

  &:hover {
    color: ${Colors.Text.base};
  }

  &:active {
    color: ${Colors.Text.active};
  }
`;

function Header() {
  return (
    <Container>
      <Brand>
        <Title href="/">Jake Kinsella</Title>
        <Tagline>Co-Founder + Lead Architect, LatentSpin</Tagline>
      </Brand>

      <Navigation>
        <NavLink href="https://www.linkedin.com/in/jake-kinsella/" target="_blank" rel="noreferrer">LinkedIn</NavLink>
        <NavLink href="https://github.com/jakekinsella" target="_blank" rel="noreferrer">GitHub</NavLink>
        <NavLinkKeep href="/about">About</NavLinkKeep>
      </Navigation>
    </Container>
  );
}

export default Header;
